import { render } from "./VendorDashboard.vue?vue&type=template&id=c28e4a52&scoped=true"
import script from "./VendorDashboard.vue?vue&type=script&lang=js"
export * from "./VendorDashboard.vue?vue&type=script&lang=js"

import "./VendorDashboard.vue?vue&type=style&index=0&id=c28e4a52&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c28e4a52"]])

export default __exports__